import React from "react";

import { Button } from "@/components/form/Button/Button";
import { TextField } from "@/components/form/text-field/TextField";
import { useFormFactory } from "@/hooks/useFormFactory";

import { useSendForgotPassword } from "./hooks";
import { ForgotPasswordFormSchema } from "./models";

export const ForgotPasswordForm: React.FC = () => {
  const { mutate } = useSendForgotPassword();
  const { onSubmitHandler, register } = useFormFactory({
    mutate,
    schema: ForgotPasswordFormSchema,
  });

  return (
    <form className="flex flex-col gap-4" onSubmit={onSubmitHandler}>
      {/* <h2 className="text-2xl text-grey1-900 font-bold">
        Password Restoration
      </h2> */}
      <p className="text-[13px] lg:text-sm">
        If you&apos;ve forgot your password, please, specify the email you used
        for registration. Your password will be sent there.
      </p>
      <TextField type="email" label="Your email" {...register("username")} />
      <Button
        variant="primary"
        onHoverVariant="color-reverse"
        type="submit"
        className="max-w-[160px]"
      >
        submit
      </Button>
    </form>
  );
};
